import RatingInfo from './RatingInfo.vue'

export default RatingInfo
